import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { getInitialVisitInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getInitialVisitInformationQueryFunction';
import {
  VisitInformationResponseType,
  VisitInformationTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';
import { getVisitInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getVisitInformation = (params: VisitInformationTypeParams) => {
  const queryFn = () => {
    if (params?.type && params.type === 'initial') {
      return getInitialVisitInformationQueryFunction(params);
    }
    return getVisitInformationQueryFunction(params);
  };
  return queryOptions({
    queryKey: ['get_vehicle_damage_amount', params],
    queryFn: () => queryFn(),
    select: (data: VisitInformationResponseType) => {
      return {
        ...data,
        visit_date: data?.visit_date
          ? convertTimestampToShamsi(Number(data?.visit_date))
          : '',
        visit_site: {
          label: data?.visit_site?.fa_const,
          value: data?.visit_site?.const,
        },

        visit_location: data?.visit_location,
      };
    },
  });
};
export default getVisitInformation;
